var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.703,
    height: 20.052,
    viewBox: "0 0 17.703 20.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M22.366,6.027a.769.769,0,0,0-.716-.09A2.684,2.684,0,0,1,19.119,5.7a2.62,2.62,0,0,1-1.171-2.232.749.749,0,0,0-.213-.542.766.766,0,0,0-.548-.234H14.14a.758.758,0,0,0-.762.753v12.9a1.9,1.9,0,1,1-1.9-1.883.758.758,0,0,0,.762-.753V10.69a.758.758,0,0,0-.762-.753A6.446,6.446,0,0,0,5,16.339a6.287,6.287,0,0,0,1.219,3.766.721.721,0,0,0,1.066.143.748.748,0,0,0,.175-1.055,4.815,4.815,0,0,1-.937-2.855A4.928,4.928,0,0,1,10.713,11.5V13A3.394,3.394,0,1,0,14.9,16.339V4.2h1.577a4.183,4.183,0,0,0,4.136,3.48,4.851,4.851,0,0,0,.571-.038V9.1a5.475,5.475,0,0,1-3.61-.625.769.769,0,0,0-.762,0,.752.752,0,0,0-.381.655v7.209a4.89,4.89,0,0,1-2.208,4.069,5.006,5.006,0,0,1-4.647.451.764.764,0,0,0-.944.424.75.75,0,0,0,.358.962,6.492,6.492,0,0,0,8.957-5.408.567.567,0,0,0,0-.121V10.3a7.028,7.028,0,0,0,4.2.121.754.754,0,0,0,.548-.753V6.69a.751.751,0,0,0-.335-.663Z",
    transform: "translate(-5 -2.69)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c82f970da0b9849f70982356d4070013.svg";
export { ForwardRef as ReactComponent };